<template>
  <Transition name="modal">
    <!-- <div v-if="props.show" class="modal_wrap loading fade-in">
      <div class="loader"></div>
    </div> -->
    <div class="modal_wrap" v-if="props.show">
      <div class="load_10">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
      </div>
    </div>
  </Transition>
</template>
<script setup lang="ts">
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});

setTimeout(() => {
  console.log('props.show------', props.show);
}, 5000);

const xx = () => {
  console.log('xx');
};
defineExpose({
  xx,
});
</script>
<style scoped>
.modal_wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: '#F0FBFB';
  /* background: rgba(0, 0, 0, 0.1); */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* ==================================================== */
.load_10 {
  width: 40px;
  height: 40px;
  display: inline-block;
  position: relative;
}
.load_10 .bounce1,
.load_10 .bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #61e8ea;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}
.load_10 .bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}
@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1.5);
  }
}
@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1.5);
  }
}
</style>
